import axios from "axios";
import Cookies from "js-cookie";

import { firebaseAPI } from "../firebaseConfig";
const programName = "SummerAcademy2025";

const axiosInstance = axios.create({
  baseURL: firebaseAPI,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Intercept 401/403 to refresh token
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      (error.response?.status === 401 || error.response?.status === 403) &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem("refreshToken");
      if (!refreshToken) {
        window.location.href = "/" + programName + "/login";
        return Promise.reject(error);
      }

      try {
        const res = await axios.post(`${firebaseAPI}/refresh`, {
          refreshToken,
        });

        const newToken = res.data.token;
        const newExpiration = new Date();
        newExpiration.setMinutes(newExpiration.getMinutes() + 15);

        // Update token in cookies
        Cookies.set("token", newToken, {
          expires: newExpiration,
          secure: true,
        });

        // Retry original request with new token
        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        console.error("Refresh token expired");
        window.location.href = "/" + programName + "/login";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
